/** FCR Omni Media whitelabel theme entry. */

import type { WhitelabelThemeEntry } from '../../types';
import { fcrDefaultTheme } from './default';

export { fcrWhitelabel } from './default';

export const fcrWhitelabelThemeEntry: WhitelabelThemeEntry = {
  themes: {
    default: fcrDefaultTheme,
  },
};
